import { numberLocale } from '@/lib/language';

/**
 * Preis und Waehrung zu einem anzeigbaren String.
 *
 * `null` heisst "zeig gar keinen Preis". Das ist die tragende Zusicherung
 * dieser Funktion: in `products.price` steht ein nackter Zahlenstring, weil
 * `process-product-sync` `amountMicros / 1e6` rechnet, und die Waehrung steht
 * erst seit dem 22.08.2026 daneben. Eine aus `feeds.target_country` geratene
 * Waehrung waere eine Falschaussage an genau der Stelle, an der ueber eine
 * Freigabe entschieden wird: ein Schweizer Feed darf in Euro auszeichnen.
 */
export function formatProductPrice(
  price: string | null,
  currency: string | null,
  language: string | null | undefined,
): string | null {
  const raw = (price ?? '').trim();
  const code = (currency ?? '').trim();
  if (raw === '' || code === '') return null;

  const value = Number(raw);
  if (!Number.isFinite(value)) return null;

  const locale = numberLocale(language);
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(value);
  } catch {
    // Intl wirft RangeError bei einem Code, der nicht dem ISO-4217-Muster
    // folgt. Aus einer krummen Datenzeile darf kein Absturz der Karte werden;
    // Zahl plus Rohcode sagt immer noch die Wahrheit.
    return `${new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)} ${code}`;
  }
}
